/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */

import echarts from 'echarts';
import Color from 'color';

/* eslint-disable import/prefer-default-export */

const RED_END = Color('#DF2023').hsl();
const BLUE_END = Color('#20DFDA').hsl();

const TABLEAU_BLUE_GRADIENT = [
	'#2b5c8a',
	'#316596',
	'#3d70a1',
	'#4b7dab',
	'#5689b7',
	'#6196c3',
	'#6da2cc',
	'#7cb1d6',
	'#8bbfdd',
	'#9bcae3',
];
const TABLEAU_ORANGE_GRADIENT = [
	'#d9d5c9',
	'#febf6e',
	'#fcac4f',
	'#f8983a',
	'#f2822b',
	'#ea6f22',
	'#de6220',
	'#cf5721',
	'#bf4e22',
	'#ae4523',
	'#9e3d22',
];
const BLUE_ORANGE_GRADIENT = [...TABLEAU_BLUE_GRADIENT, ...TABLEAU_ORANGE_GRADIENT];
const generateTableauBlueGradient = (count) => {
	const gradient = [];
	const hop = TABLEAU_BLUE_GRADIENT.length / count;
	for (let i = 0; i < TABLEAU_BLUE_GRADIENT.length; i += hop) {
		gradient.push(TABLEAU_BLUE_GRADIENT[Math.floor(i)]);
	}
	// make sure the last color is last color of the gradient
	// gradient[gradient.length - 1] = '#d9d5c9';
	return gradient;
};
const generateTableauOrangeGradient = (count) => {
	const gradient = [];
	const hop = TABLEAU_ORANGE_GRADIENT.length / count;
	for (let i = 0; i < TABLEAU_ORANGE_GRADIENT.length; i += hop) {
		gradient.push(TABLEAU_ORANGE_GRADIENT[Math.floor(i)]);
	}
	return gradient;
};
const generateTableauBlueColorStops = (count, totalCount) => {
	const colorStops = [];
	const hop = TABLEAU_BLUE_GRADIENT.length / count;
	let counter = 0;
	for (let i = 0; i < TABLEAU_BLUE_GRADIENT.length; i += hop) {
		const offset = 1 - counter / totalCount;
		if (offset !== 0.5) {
			colorStops.push({
				offset,
				color: TABLEAU_BLUE_GRADIENT[Math.floor(i)],
			});
		}
		counter += 1;
	}
	return colorStops;
};
const generateTableauOrangeColorStops = (count, totalCount) => {
	const colorStops = [];
	const hop = TABLEAU_ORANGE_GRADIENT.length / count;
	let counter = 0;
	const offset = (totalCount - count) / totalCount;
	for (let i = 0; i < TABLEAU_ORANGE_GRADIENT.length; i += hop) {
		colorStops.push({
			offset: 1 - offset - counter / totalCount,
			color: TABLEAU_ORANGE_GRADIENT[Math.floor(i)],
		});
		counter += 1;
	}
	return colorStops;
};
const generateTableauBlueOrangeGradient = (leftCount, rightCount) => [
	...generateTableauBlueGradient(leftCount),
	...generateTableauOrangeGradient(rightCount),
];
const generateTableauBlueOrangeColorStops = (leftCount, rightCount) => [
	...generateTableauBlueColorStops(leftCount, leftCount + rightCount),
	...generateTableauOrangeColorStops(rightCount, leftCount + rightCount),
];

const ELECTRIC_BLUE_GRADIENT = [
	'#115e85',
	'#115e85',
	'#256a8d',
	'#377493',
	'#4b809b',
	'#608ca2',
	'#7397a9',
	'#87a3b1',
	'#99adb7',
	'#adb9bf',
	'#cccccc',
];
const ELECTRIC_RED_GRADIENT = [
	'#cccccc',
	'#cabdbc',
	'#c9aeac',
	'#c79f9c',
	'#c6918d',
	'#c4827d',
	'#c2736d',
	'#c0645d',
	'#be554d',
	'#bd463d',
	'#BB372E',
	'#BB372E',
];
const ELECTRIC_BLUE_RED_GRADIENT = [...ELECTRIC_BLUE_GRADIENT, ...ELECTRIC_RED_GRADIENT];
const generateElectricBlueGradient = (count) => {
	const gradient = [];
	const hop = ELECTRIC_BLUE_GRADIENT.length / count;
	for (let i = 0; i < ELECTRIC_BLUE_GRADIENT.length; i += hop) {
		gradient.push(ELECTRIC_BLUE_GRADIENT[Math.floor(i)]);
	}
	return gradient;
};
const generateElectricRedGradient = (count) => {
	const gradient = [];
	const hop = ELECTRIC_RED_GRADIENT.length / count;
	for (let i = 0; i < ELECTRIC_RED_GRADIENT.length; i += hop) {
		gradient.push(ELECTRIC_RED_GRADIENT[Math.floor(i)]);
	}
	return gradient;
};
const generateElectricBlueColorStops = (count, totalCount) => {
	const colorStops = [];
	const hop = ELECTRIC_BLUE_GRADIENT.length / count;
	let counter = 0;
	for (let i = 0; i < ELECTRIC_BLUE_GRADIENT.length; i += hop) {
		const offset = 1 - counter / totalCount;
		if (offset !== 0.5) {
			colorStops.push({
				offset,
				color: ELECTRIC_BLUE_GRADIENT[Math.floor(i)],
			});
		}
		counter += 1;
	}
	return colorStops;
};
const generateElectricRedColorStops = (count, totalCount) => {
	const colorStops = [];
	const hop = ELECTRIC_RED_GRADIENT.length / count;
	let counter = 0;
	const offset = (totalCount - count) / totalCount;
	for (let i = 0; i < ELECTRIC_RED_GRADIENT.length; i += hop) {
		colorStops.push({
			offset: 1 - offset - counter / totalCount,
			color: ELECTRIC_RED_GRADIENT[Math.floor(i)],
		});
		counter += 1;
	}
	return colorStops;
};
const generateElectricBlueRedGradient = (leftCount, rightCount) => [
	...generateElectricBlueGradient(leftCount),
	...generateElectricRedGradient(rightCount),
];
const generateElectricBlueRedColorStops = (leftCount, rightCount) => [
	...generateElectricBlueColorStops(leftCount, leftCount + rightCount),
	...generateElectricRedColorStops(rightCount, leftCount + rightCount),
];

const generateMultichromaticRedGradient = (count) => {
	const gradient = [];
	for (let i = count - 1; i >= 0; i -= 1) {
		gradient.push(RED_END.rotate((i * 90) / count).hex());
	}
	return gradient;
};

const generateMultichromaticBlueGradient = (count) => {
	const gradient = [];
	for (let i = count - 1; i >= 0; i -= 1) {
		gradient.push(BLUE_END.rotate((i * 120) / count).hex());
	}
	return gradient;
};

const generateMultichromaticBlueColorStops = (count, totalCount) => {
	const colorStops = [];
	let counter = 0;
	for (let i = count - 1; i >= 0; i -= 1) {
		colorStops.push({
			offset: 1 - counter / totalCount,
			color: BLUE_END.rotate((i * 120) / count).hex(),
		});
		counter += 1;
	}
	return colorStops;
};

const generateMultichromaticRedColorStops = (count, totalCount) => {
	const colorStops = [];
	let counter = 0;
	const offset = (totalCount - count) / totalCount;
	for (let i = count - 1; i >= 0; i -= 1) {
		colorStops.push({
			offset: 1 - offset - counter / totalCount,
			color: RED_END.rotate((i * 90) / count).hex(),
		});
		counter += 1;
	}
	return colorStops;
};

const generateMultiChromaticBlueRedGradient = (leftCount, rightCount) => [
	...generateMultichromaticBlueGradient(leftCount),
	...generateMultichromaticRedGradient(rightCount),
];

const generateMultiChromaticBlueRedColorStops = (leftCount, rightCount) => [
	...generateMultichromaticBlueColorStops(leftCount, leftCount + rightCount),
	...generateMultichromaticRedColorStops(rightCount, leftCount + rightCount),
];

const GRADIENTS = {
	ELECTRIC_BLUE_RED: 'ELECTRIC_BLUE_RED',
	MULTICHROMA: 'MULTICHROMA',
	BLUE_ORANGE: 'BLUE_ORANGE',
	GREEN: 'GREEN',
};

const THEMES = {
	PINPOINT: 'PINPOINT',
	PINPOINT1: 'PINPOINT1',
	PINPOINT2: 'PINPOINT2',
	PINPOINT3: 'PINPOINT3',
	PINPOINT4: 'PINPOINT4',
	PINPOINT5: 'PINPOINT5',
	PINPOINT6: 'PINPOINT6',
};

const generateGradient = (leftCount, rightCount, theme = GRADIENTS.ELECTRIC_BLUE_RED) => {
	switch (theme) {
		case GRADIENTS.MULTICHROMA:
			return generateMultiChromaticBlueRedGradient(leftCount, rightCount);
		case GRADIENTS.BLUE_ORANGE:
			return generateTableauBlueOrangeGradient(leftCount, rightCount);
		case GRADIENTS.ELECTRIC_BLUE_RED:
			return generateElectricBlueRedGradient(leftCount, rightCount);
		default:
			return generateElectricBlueRedGradient(leftCount, rightCount);
	}
};

const generateColorStops = (leftCount, rightCount, theme = GRADIENTS.ELECTRIC_BLUE_RED) => {
	switch (theme) {
		case GRADIENTS.MULTICHROMA:
			return generateMultiChromaticBlueRedColorStops(leftCount, rightCount);
		case GRADIENTS.BLUE_ORANGE:
			return generateTableauBlueOrangeColorStops(leftCount, rightCount);
		case GRADIENTS.ELECTRIC_BLUE_RED:
			return generateElectricBlueRedColorStops(leftCount, rightCount);
		default:
			return generateElectricBlueRedColorStops(leftCount, rightCount);
	}
};

const COLORS = {
	GRADIENTS,
	THEMES,
	generateGradient,
	generateColorStops,
	BRAND: '#0080BA',
	OPENNESS: {
		PRIMARY: '#C635A8',
		LIGHT: '#E499CF',
		TEXT: '#EEE',
	},
	CONSCIENTIOUSNESS: {
		PRIMARY: '#3AA6E8',
		LIGHT: '#9CD2F3',
		TEXT: '#FFF',
	},
	EXTRAVERSION: {
		PRIMARY: '#00C08B',
		LIGHT: '#7FDFC5',
		TEXT: '#333333',
	},
	AGREEABLENESS: {
		PRIMARY: '#C2D500',
		LIGHT: '#E0EA7F',
		TEXT: '#333333',
	},
	NEUROTICISM: {
		PRIMARY: '#F69627',
		LIGHT: '#FFDC7F',
		TEXT: '#333333',
	},
	DEMOGRAPHIC: {
		PRIMARY: '#666F75',
		LIGHT: '#D5D8DA',
		TEXT: '#FFF',
	},
	WHITE: '#FFFFFF',
	LOW_RED: '#FF6663',
	HIGH_GREEN: '#6EB257',
	PINPOINT_GREEN: '#41C1AB',
	OCEAN_CSS: {
		background:
			'linear-gradient(90deg, #E721C4, #E721C4 20%, #01A6E8 21%, #01A6E8 40%, #0EE0A9 41%, #0EE0A9 60%, #CEDE58 61%, #CEDE58 80%, #FDC744 81%, #FDC744)',
	},
	MULTICHROMATIC_CSS: {
		background:
			'linear-gradient(45deg, #B420DF, #8E20DF 5%, #6720DF 10%, #4120DF 20%, #2025DF 25%, #204BDF 30%, #2071DF 35%, #2098DF 40%, #20BEDF 45%, #20DFDA 50%, #9FDf20 55%, #BCDF20 60%, #D8DF20 65%, #DFC920 70%, #DFAC20 75%, #DF9020 80%, #DF7320 85%, #DF5620 90%, #DF3A30 95%, #DF2023)',
	},
	BLUE_ORANGE_GRADIENT,
	BLUE_ORANGE_CSS: {
		background:
			'linear-gradient(45deg, #2B5C8A, #316596 5%, #3d70a1 10%, #4b7dab 15%, #5689b7 20%, #6196c3 25%, #6da2cc 30%, #7cb1d6 35%, #8bbfdd 40%, #9bcae3 45%, #d9d5c9 50%, #febf6e 55%, #fcac4f 60%, #f8983a 65%, #f2822b 70%, #ea6f22 75%, #de6220 80%, #cf5721 85%, #bf4e22 90%, #ae4523 95%, #9e3d22)',
	},
	ELECTRIC_BLUE_RED_CSS: {
		background:
			'linear-gradient(45deg, #115e85, #256a8d, #377493, #4b809b, #608ca2, #7397a9,#87a3b1, #99adb7, #adb9bf 47%, #cccccc 50%, #d1c1c0 53%, #d0b6b4, #cfa7a4, #cc9490, #c87d78, #c4635d, #bf463e,#BB372E)',
	},
	ELECTRIC_BLUE_RED_GRADIENT,
	GREEN_GRADIENT_CSS: {
		background:
			'linear-gradient(-135deg, #DFF5D6, #B0EAAF 10%, #89DEA0 20%, #64D0A0 30%, #41C1AB 40%, #37A6AB 70%, #2D7A94 80%, #24547D 90%, #1C3465)',
	},
	GREEN_GRADIENT_COLOR_STOPS: [
		{
			offset: 1,
			color: '#1C3465',
		},
		{
			offset: 0.9,
			color: '#24547D',
		},
		{
			offset: 0.8,
			color: '#2D7A94',
		},
		{
			offset: 0.7,
			color: '#37A6AB',
		},
		{
			offset: 0.4,
			color: '#41C1AB',
		},
		{
			offset: 0.3,
			color: '#64D0A0',
		},
		{
			offset: 0.2,
			color: '#89DEA0',
		},
		{
			offset: 0.1,
			color: '#B0EAAF',
		},
		{
			offset: 0,
			color: '#DFF5D6',
		},
	],
};

const LABEL_FONT_SIZE = 14;

const global = {
	title: {
		left: 'center',
		top: '24px',
		textStyle: {
			fontFamily: 'Roboto',
			fontSize: LABEL_FONT_SIZE + 8,
			fontWeight: '400',
		},
	},
	textStyle: {
		fontFamily: 'Roboto',
		fontWeight: '200',
	},
	legend: {
		itemGap: 24,
		icon: 'circle',
		textStyle: {
			fontWeight: '200',
			fontSize: LABEL_FONT_SIZE,
		},
	},
	label: {
		show: true,
		fontSize: LABEL_FONT_SIZE,
		fontWeight: '200',
	},
	tooltip: {
		textStyle: {
			fontWeight: '200',
		},
	},
	backgroundColor: 'transparent',
	grid: {
		containLabel: false,
	},
	toolbox: {
		show: true,
		feature: {
			saveAsImage: {
				show: true,
				name: 'OnpointChart',
				title: 'download',
				iconStyle: {
					emphasis: {
						textAlign: 'right',
					},
				},
			},
		},
	},
	xAxis: {
		nameTextStyle: {
			fontSize: LABEL_FONT_SIZE + 1,
			lineHeight: LABEL_FONT_SIZE * 1.4,
		},
	},
	yAxis: {
		nameTextStyle: {
			fontSize: LABEL_FONT_SIZE + 1,
		},
	},
};

export default {
	COLORS,
	global,
	Lift: {
		grid: {
			containLabel: false,
			paddingBottom: '10%',
		},
		xAxis: {
			name: 'Thinkalike Score percentile buckets',
			nameTextStyle: {
				fontSize: LABEL_FONT_SIZE,
			},
			nameLocation: 'center',
			nameGap: 30,
			axisTick: {
				show: false,
			},
			axisPointer: {
				label: {
					formatter: (params) => `${params.value - 10} - ${params.value} percentile of users`,
				},
			},
			axisLabel: {
				fontSize: LABEL_FONT_SIZE,
			},
		},
		textStyle: {
			...global.textStyle,
		},
		label: {
			...global.label,
			show: false,
		},
		yAxis: {
			axisLabel: {
				fontSize: LABEL_FONT_SIZE,
			},
		},
		tooltip: {
			trigger: 'axis',
			axisPointer: {
				type: 'cross',
			},
		},
		Line: {
			grid: {
				bottom: '25%',
			},
			yAxis: {
				nameLocation: 'end',
				nameGap: 40,
				nameRotate: 0,
				nameTextStyle: {
					fontSize: LABEL_FONT_SIZE + 1,
				},
				splitLine: {
					show: false,
				},
				axisTick: {
					show: false,
				},
				axisLabel: {
					formatter: (value) => `${value.toFixed(1)}`,
					fontSize: LABEL_FONT_SIZE,
				},
				axisPointer: {
					label: {
						formatter: (params) => `${params.value.toFixed(1)}`,
					},
				},
			},
			xAxis: {
				axisLabel: {
					fontSize: LABEL_FONT_SIZE,
				},
				nameTextStyle: {
					fontSize: LABEL_FONT_SIZE + 1,
				},
				nameGap: 20,
			},
			series: {
				color: ['#999', '#999', '#999'],
				showSymbol: false,
				lineStyle: {
					width: 5,
					color: '#999',
				},
			},
			markLine: {
				slient: true,
				symbol: 'none',
				label: {
					formatter: 'Average Lift / Engagement Percentage',
					position: 'insideStartTop',
				},
				lineStyle: {
					color: '#999',
					width: 1,
				},
			},
		},
		Bar: {
			grid: {
				...global.grid,
				bottom: '25%',
			},
			textStyle: {
				...global.textStyle,
			},
			yAxis: {
				nameLocation: 'middle',
				nameGap: 70,
				nameRotate: 90,
				nameTextStyle: {
					fontSize: LABEL_FONT_SIZE + 1,
				},
				axisTick: {
					show: false,
				},
				axisLabel: {
					formatter: (value) => `${value.toFixed(1)}%`,
					fontSize: LABEL_FONT_SIZE,
				},
				splitNumber: 10,
				axisPointer: {
					label: {
						formatter: (params) => `${params.value.toFixed(1)}%`,
					},
				},
			},
			xAxis: {
				axisLabel: {
					fontSize: LABEL_FONT_SIZE,
				},
			},
			series: {
				animationDelay: () => Math.random() * 200,
				itemStyle: {
					barBorderRadius: [4, 4, 0, 0],
					opacity: 0.7,
				},
			},
		},
	},
	Slider: {
		Scatter: {
			series: {
				symbol: 'roundRect',
				symbolSize: [15, 30],
			},
			itemStyle: {
				shadowBlur: 3,
				shadowOffsetX: 2,
				shadowOffsetY: 2,
			},
			label: {
				...global.label,
				color: '#666',
				show: true,
				position: 'top',
			},
		},
		textStyle: {
			...global.textStyle,
		},
		grid: {
			top: '30',
			bottom: '70',
			left: '20%',
			right: '20%',
		},
		yAxis: {
			axisLabel: {
				fontSize: LABEL_FONT_SIZE + 1,
			},
		},
		xAxis: {
			nameLocation: 'middle',
			nameGap: 24,
			nameTextStyle: {
				fontSize: LABEL_FONT_SIZE + 1,
			},
			axisLabel: {
				fontSize: LABEL_FONT_SIZE,
			},
		},
		areaStyle: () => ({
			color: new echarts.graphic.LinearGradient(
				0,
				0,
				1,
				0,
				COLORS.ELECTRIC_BLUE_RED_GRADIENT.map((color, index, array) => ({
					offset: index / array.length,
					color,
				}))
			),
		}),
		lineStyle: {
			color: '#333',
			width: 0,
			shadowBlur: 0,
		},
		series: {
			animation: true,
		},
		legend: {
			...global.legend,
			padding: [5, 0, 0, 0],
		},
	},
	NormalDistribution: {
		areaStyle: (factor) => ({
			color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
				{
					offset: 0,
					color: COLORS[factor.toUpperCase()].PRIMARY,
				},
				{
					offset: 0.5,
					color: COLORS[factor.toUpperCase()].LIGHT,
				},
				{
					offset: 1,
					color: COLORS[factor.toUpperCase()].PRIMARY,
				},
			]),
		}),
		textStyle: {
			...global.textStyle,
		},
		label: {
			...global.label,
		},
		lineStyle: {
			color: '#000000',
			width: 0,
			shadowBlur: 3,
		},
		markPoint: {
			label: {
				color: '#FFF',
			},
			itemStyle: {
				color: '#000',
				opacity: 0.8,
			},
			animation: false,
		},
		markLine: {
			symbol: 'none',
			label: {
				position: 'start',
			},
			lineStyle: {
				color: '#000',
				opacity: 0.4,
			},
			animation: false,
		},
		series: {
			animation: false,
		},
	},
	Gauge: {
		itemStyle: {
			color: '#000000',
			opacity: 0.5,
		},
		textStyle: {
			...global.textStyle,
		},
		label: {
			...global.label,
		},
		pointer: {
			length: '91%',
			width: '2%',
			show: true,
		},
		axisLabel: {
			show: true,
			fontSize: LABEL_FONT_SIZE,
			textStyle: {
				fontSize: LABEL_FONT_SIZE,
				color: '#000000',
				padding: [0, -10, 0, -10],
			},
		},
		title: {
			offsetCenter: ['0', '88%'],
			fontSize: LABEL_FONT_SIZE + 2,
			color: '#000000',
		},
		axisLine: (factor) => ({
			lineStyle: {
				width: 15,
				color: [
					[
						0.5,
						new echarts.graphic.LinearGradient(0, 1, 0, 0, [
							{
								offset: 0,
								color: COLORS[factor.toUpperCase()].PRIMARY,
							},
							{
								offset: 1,
								color: COLORS[factor.toUpperCase()].LIGHT,
							},
						]),
					],
					[
						1,
						new echarts.graphic.LinearGradient(0, 0, 0, 1, [
							{
								offset: 0,
								color: COLORS[factor.toUpperCase()].LIGHT,
							},
							{
								offset: 1,
								color: COLORS[factor.toUpperCase()].PRIMARY,
							},
						]),
					],
				],
			},
		}),
		axisTick: {
			show: true,
			lineStyle: {
				width: 1,
				color: '#000000',
				opacity: 0,
			},
		},
		splitNumber: 10,
		splitLine: {
			show: false,
			length: 35,
			lineStyle: {
				width: 1,
				color: '#000000',
				opacity: 0.5,
			},
		},
		detail: {
			show: true,
			offsetCenter: ['0', '55%'],
			fontSize: LABEL_FONT_SIZE * 2,
			fontWeight: '400',
		},
	},
	Nightingale: {
		series: {
			animationType: 'scale',
			animationEasing: 'elasticOut',
			animationDelay: () => Math.random() * 200,
			radius: ['15%', '85%'],
		},
		visualMap: (factor) => ({
			inRange: {
				color: [COLORS[factor.toUpperCase()].LIGHT, COLORS[factor.toUpperCase()].PRIMARY],
			},
		}),
		selectedItemStyle: {
			shadowBlur: 2,
			shadowOffsetX: -1,
			shadowOffsetY: -1,
			shadowColor: '#909090',
			borderColor: '#FFF',
			borderWidth: 4,
		},
		itemStyle: (factor, proportion, shade) => {
			if (shade) {
				const lightenedColor = Color(COLORS[factor.toUpperCase()].PRIMARY)
					.lighten(proportion / 2)
					.hex()
					.toString();
				return {
					color:
						lightenedColor === '#FFFFFF'
							? Color(COLORS[factor.toUpperCase()].LIGHT)
									.darken(1 - proportion / 2)
									.hex()
									.toString()
							: lightenedColor,
					borderWidth: 1,
					borderColor: '#FFFFFF',
				};
			}
			return {
				color: COLORS[factor.toUpperCase()].PRIMARY,
				borderWidth: 1,
				borderColor: '#FFFFFF',
			};
		},
		label: {
			...global.label,
			color: '#333',
			lineHeight: 16,
			position: 'outside',
		},
		textStyle: {
			...global.textStyle,
		},
		tooltip: {
			formatter: (params) =>
				`The ${params.data.trait} score for this Customer Group is in the ${params.data.percentile.toFixed(
					1
				)}th percentile, making it more ${params.data.rangeName} than ${Math.max(
					params.data.percentile,
					100 - params.data.percentile
				).toFixed(1)}% of the US population`.replace(/(?![^\n]{1,64}$)([^\n]{1,64})\s/g, '$1<br />'),
			textStyle: {
				fontSize: LABEL_FONT_SIZE + 2,
			},
		},
	},
	Radar: {
		radar: {
			shape: 'polygon',
			silent: false,
			triggerEvent: true,
			name: {
				color: '#333',
				fontSize: LABEL_FONT_SIZE + 1,
			},
		},
		textStyle: {
			...global.textStyle,
		},
		legend: {
			...global.legend,
			top: 'bottom',
			padding: [0, 0, 16, 0],
			textStyle: {
				fontSize: LABEL_FONT_SIZE + 1,
			},
		},
		label: {
			...global.label,
			color: '#666',
		},
		series: {
			symbol: 'circle',
			symbolSize: 1,
		},
		startAngle: (labels) => 90 + 360 / labels.length,
		axisLine: {
			show: true,
			lineStyle: {
				color: ['#CCC'],
			},
		},
		splitLine: {
			show: true,
			lineStyle: {
				color: ['#AAA', '#AAA', '#AAA', '#AAA', '#AAA', '#999', '#AAA', '#AAA', '#AAA', '#AAA', '#AAA', '#AAA'],
			},
		},
		splitArea: {
			show: true,
			areaStyle: {
				color: [
					'#E0E0E0',
					'#E0E0E0',
					'#E0E0E0',
					'#E0E0E0',
					'#E0E0E0',
					'#FEFEFE',
					'#FEFEFE',
					'#FEFEFE',
					'#FEFEFE',
					'#FEFEFE',
					'#FEFEFE',
				],
			},
		},
		itemStyle: {},
		lineStyle: {
			width: 0,
			opacity: 0,
		},
		areaStyle: {},
	},
	Heatmap: {
		grid: {
			...global.grid,
			top: '20px',
			bottom: '20px',
		},
		textStyle: {
			...global.textStyle,
		},
		label: {
			...global.label,
			color: '#666',
			show: false,
		},
		xAxis: {
			position: 'top',
			axisLine: {
				show: false,
			},
			axisTick: {
				show: false,
			},
			splitLine: {
				show: false,
			},
			axisLabel: {
				show: true,
				interval: 0,
				fontSize: LABEL_FONT_SIZE,
			},
		},
		yAxis: {
			axisLine: {
				show: false,
			},
			axisTick: {
				show: false,
			},
			splitLine: {
				show: false,
			},
			axisLabel: {
				show: true,
				interval: 0,
				fontSize: LABEL_FONT_SIZE - 2,
				fontWeight: 200,
			},
		},
		visualMap: {
			series: {},
			strength: {
				inRange: {
					color: ['#E9E6F8', COLORS.BRAND],
				},
			},
		},
	},
	VerticalBar: {
		itemStyle: {},
		textStyle: {
			...global.textStyle,
		},
		label: {
			...global.label,
		},
		tooltip: {
			show: true,
		},
		grid: {
			...global.grid,
			top: 100,
			bottom: 60,
		},
		visualMap: {
			bottom: 'auto',
			top: 50,
			type: 'continuous',
			calculable: true,
			orient: 'horizontal',
			left: 'center',
			itemHeight: 600,
			precision: 2,
		},
		xAxis: {
			nameLocation: 'center',
			nameGap: 40,
			name: 'Thinkalike Score percentile buckets, segmenting Validation Set',
			nameTextStyle: {
				fontSize: LABEL_FONT_SIZE + 1,
			},
			axisLabel: {
				show: true,
				interval: 0,
				fontSize: LABEL_FONT_SIZE,
			},
			axisTick: {
				show: false,
			},
		},
		yAxis: {
			name: 'Lift',
			nameLocation: 'end',
			nameTextStyle: {
				fontSize: LABEL_FONT_SIZE,
			},
			type: 'value',
			splitNumber: 10,
			axisLabel: {
				show: true,
				interval: 0,
				fontSize: LABEL_FONT_SIZE - 1,
			},
		},
	},
	Bar: {
		itemStyle: {
			barBorderRadius: [0, 4, 4, 0],
		},
		grid: {
			...global.grid,
		},
		textStyle: {
			...global.textStyle,
		},
		label: {
			...global.label,
			color: '#FFF',
			position: 'insideRight',
		},
		xAxis: {
			...global.xAxis,
			name: 'Median Percentile Score',
			nameLocation: 'center',
			nameGap: 30,
			type: 'value',
			position: 'bottom',
			splitNumber: 10,
			interval: 10,
		},
		yAxis: {
			...global.yAxis,
			name: 'Ranges',
			nameLocation: 'start',
			inverse: true,
			axisLabel: {
				show: true,
				interval: 0,
				fontSize: LABEL_FONT_SIZE,
			},
			axisTick: {
				show: false,
			},
		},
	},
	Tornado: {
		textStyle: {
			...global.textStyle,
		},
		left: {
			series: {
				label: {
					...global.label,
					position: 'insideLeft',
				},
				itemStyle: {
					barBorderRadius: [4, 0, 0, 4],
				},
			},
			xAxis: {
				...global.xAxis,
				name: 'Percentile distance from the median',
				nameLocation: 'middle',
				nameGap: 40,
				type: 'value',
				position: 'bottom',
				interval: 10,
				inverse: true,
				axisLabel: {
					show: true,
					interval: 0,
					fontSize: LABEL_FONT_SIZE,
				},
				axisTick: {
					show: true,
				},
			},
			yAxis: {
				...global.yAxis,
				type: 'category',
				position: 'left',
				inverse: true,
				axisLine: {
					show: false,
				},
				axisLabel: {
					show: true,
					interval: 0,
					fontSize: LABEL_FONT_SIZE,
				},
				axisTick: {
					show: false,
				},
				data: {
					textStyle: {
						align: 'right',
					},
				},
			},
		},
		center: {
			xAxis: {
				show: false,
			},
			yAxis: {
				...global.yAxis,
				type: 'category',
				inverse: true,
				axisLine: {
					show: false,
				},
				axisTick: {
					show: false,
				},
				axisLabel: {
					show: true,
					interval: 0,
					fontSize: LABEL_FONT_SIZE,
					fontWeight: 'bold',
				},
				splitLine: {
					show: false,
				},
				data: {
					textStyle: {
						align: 'center',
						fontWeight: 'bold',
					},
				},
			},
		},
		right: {
			series: {
				label: {
					...global.label,
					position: 'insideRight',
				},
				itemStyle: {
					barBorderRadius: [0, 4, 4, 0],
				},
			},
			xAxis: {
				...global.xAxis,
				name: 'Percentile distance from the median',
				nameLocation: 'middle',
				nameGap: 40,
				type: 'value',
				position: 'bottom',
				interval: 10,
				axisLabel: {
					show: true,
					interval: 0,
					fontSize: LABEL_FONT_SIZE,
				},
				axisTick: {
					show: true,
				},
			},
			yAxis: {
				...global.yAxis,
				type: 'category',
				inverse: true,
				position: 'right',
				axisLine: {
					show: false,
				},
				axisLabel: {
					show: true,
					interval: 0,
					fontSize: LABEL_FONT_SIZE,
				},
				axisTick: {
					show: false,
				},
				data: {
					textStyle: {
						align: 'left',
					},
				},
			},
		},
	},
	DeepOcean: {
		tooltip: {
			show: true,
			formatter: (params) =>
				`<span style="background-color:${
					params.color
				};min-width:12px;min-height:12px;border-radius:50%;display:inline-block;vertical-align:middle;"></span> ${
					params.name
				} ${params.value.toFixed(1)}`,
		},
		series: {
			startAngle: 90,
			radius: ['15%', '50%'],
			roseType: 'area',
			animationType: 'scale',
			animationEasing: 'elasticOut',
			avoidLabelOverlap: false,
			label: {
				show: true,
				rotate: 'radial',
				fontSize: LABEL_FONT_SIZE - 2,
			},
			labelLine: {
				show: false,
				length2: 1,
				smooth: true,
				emphasis: {
					show: true,
				},
			},
			itemStyle: {
				borderColor: '#FFF',
				borderWidth: 1,
			},
			emphasis: {},
		},
	},
	Tal: {
		Line: {
			xAxis: {
				name: 'Thinkalike Score percentile buckets',
				nameTextStyle: {
					fontSize: LABEL_FONT_SIZE,
				},
				nameLocation: 'center',
				nameGap: 40,
				boundaryGap: false,
			},
			textStyle: {
				...global.textStyle,
			},
			label: {
				...global.label,
			},
			grid: {
				top: 70,
				bottom: 80,
			},
			yAxis: {
				name: 'Lift',
				nameTextStyle: {
					fontSize: LABEL_FONT_SIZE,
				},
			},
			series: {
				markLine: {
					silent: true,
					label: {
						formatter: 'Average Lift',
					},
					data: [
						{
							name: 'Average Lift',
							yAxis: 1,
						},
					],
				},
				areaStyle: {
					color: {
						type: 'linear',
						x: 0,
						y: 0,
						x2: 0,
						y2: 1,
						colorStops: COLORS.GREEN_GRADIENT_COLOR_STOPS,
					},
				},
				itemStyle: {},
				lineStyle: {
					width: 5,
				},
			},
			tooltip: {
				show: true,
			},
		},
	},
	Histogram: {
		series: {
			itemStyle: {
				barBorderRadius: [4, 4, 0, 0],
			},
			animationDelay: (idx) => idx * 10 + 150,
		},
		grid: {
			top: '15%',
			bottom: 100,
		},
		title: {
			text: 'Lift',
			textStyle: {
				fontSize: LABEL_FONT_SIZE,
				fontWeight: 'small',
			},
		},
		textStyle: {
			...global.textStyle,
		},
		label: {
			...global.label,
			show: false,
		},
		tooltip: {},
		xAxis: {
			name: 'Thinkalike Score: Predicted similarity to training set',
			nameTextStyle: {
				fontSize: LABEL_FONT_SIZE + 1,
			},
			nameLocation: 'center',
			nameGap: 30,
			type: 'category',
			axisLabel: {
				show: true,
				fontSize: LABEL_FONT_SIZE,
			},
			axisTick: {
				show: false,
			},
			splitLine: {
				show: false,
			},
		},
		yAxis: {
			name: 'Number of users',
			nameTextStyle: {
				fontSize: LABEL_FONT_SIZE,
			},
			type: 'value',
			position: 'bottom',
			axiLabel: {
				fontSize: LABEL_FONT_SIZE,
			},
		},
		visualMap: {
			bottom: 'auto',
			top: 50,
			type: 'continuous',
			calculable: true,
			orient: 'horizontal',
			left: 'center',
			itemHeight: 600,
			precision: 2,
		},
		dataZoom: [
			{
				type: 'slider',
				xAxisIndex: 0,
			},
		],
	},
	PxHistogram: {
		grid: {
			...global.grid,
		},
		tooltip: {
			show: false,
		},
		textStyle: {
			...global.textStyle,
		},
		label: {
			...global.label,
			show: false,
		},
		legend: {
			...global.legend,
			textStyle: {
				fontSize: LABEL_FONT_SIZE + 1,
			},
			show: true,
		},
		xAxis: {
			show: false,
			silent: false,
			splitLine: {
				show: false,
			},
		},
		yAxis: {
			show: false,
		},
		series: {
			itemStyle: {
				barBorderRadius: [10, 10, 0, 0],
				opacity: 0.5,
			},
			barGap: '-100%',
			barCategoryGap: '5%',
			animationEasing: 'quinticInOut',
		},
	},
};
